// import React, { useState } from "react";

// const CommonMultiSelect = ({ options1, placeholder, callbackvalue }) => {
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   const handleChange = (event) => {
//     const value = event.target.value;

//     setSelectedOptions((prevSelectedOptions) => {
//       if (prevSelectedOptions.includes(value)) {
//         return prevSelectedOptions.filter((option) => option !== value);
//       } else {
//         return [...prevSelectedOptions, value];
//       }
//     });
//   };

//   const handleActiveButtonClick = () => {
//     const selectedValues = selectedOptions.join(",");
//     console.log("Selected Values:", selectedValues);
//     callbackvalue(selectedValues);
//   };

//   const filteredOptions = options1.filter((option) =>
//     option.label.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Sort selected items to appear first
//   const sortedOptions = filteredOptions.sort((a, b) => {
//     const aSelected = selectedOptions.includes(a.value.toString());
//     const bSelected = selectedOptions.includes(b.value.toString());
//     return bSelected - aSelected; // Selected items appear first
//   });

//   const renderButtonLabel = () => {
//     if (selectedOptions.length > 0) {
//       const selectedLabels = options1
//         .filter((option) => selectedOptions.includes(option.value.toString()))
//         .map((option) => option.label);
//       return `${selectedLabels.length} ${placeholder}`;
//     }
//     return placeholder;
//   };

//   return (
//     <div className="form-group">
//       <div className="d-flex">
//         <div className="dropdown">
//           <button
//             className="btn btn-secondary btn-drops rounded-0 rounded-start dropdown-toggle"
//             // className="btn btn-secondary btn-drops rounded-0 rounded-start dropdown-toggle bg-light text-dark"
//             type="button"
//             id="multiSelectDropdown"
//             data-bs-toggle="dropdown"
//             aria-expanded="false"
//           >
//             {renderButtonLabel()}
//           </button>

//           {/* <ul
//             className="dropdown-menu custom-scrollable-menu"
//             aria-labelledby="multiSelectDropdown"
//             style={{ height: "400px", overflowY: "scroll", width : "fit-content" , maxWidth:"1000px" }}
//           >
//             <li>
//               <input
//                 type="text"
//                 className="form-control border-0"
//                 placeholder="Search..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </li>
//             {sortedOptions.map((option, index) => (
//               <li
//                 key={option.value}
//                 className={index >= 7 ? "scrollable-item" : ""}
//               >
//                 <label>
//                   <input
//                     type="checkbox"
//                     value={option.value}
//                     checked={selectedOptions.includes(option.value.toString())}
//                     onChange={handleChange}
//                     className="ml-2 mr-2"
//                   />
//                   {option.label}
//                 </label>
//               </li>
//             ))}
//           </ul> */}
//           <ul
//   className="dropdown-menu custom-scrollable-menu"
//   aria-labelledby="multiSelectDropdown"
// >
//   <li>
//     <input
//       type="text"
//       className="form-control border-0"
//       placeholder="Search..."
//       value={searchTerm}
//       onChange={(e) => setSearchTerm(e.target.value)}
//     />
//   </li>
//   {sortedOptions.map((option, index) => (
//     <li key={option.value} className={index >= 7 ? "scrollable-item" : ""}>
//       <label>
//         <input
//           type="checkbox"
//           value={option.value}
//           checked={selectedOptions.includes(option.value.toString())}
//           onChange={handleChange}
//           className="ml-2 mr-2"
//         />
//         {option.label}
//       </label>
//     </li>
//   ))}
// </ul>

//           <button title="Apply Filter"
//           className="btn btn-secondary rounded-0 rounded-end"
//           onClick={handleActiveButtonClick}
//         >
//           <i class="fas fa-filter"></i>
//         </button>
//         </div>
      
//       </div>
//     </div>
//   );
// };

// export default CommonMultiSelect;

import React, { useState } from "react";

const CommonMultiSelect = ({ options1, placeholder, callbackvalue }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;

    setSelectedOptions((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(value)) {
        return prevSelectedOptions.filter((option) => option !== value);
      } else {
        return [...prevSelectedOptions, value];
      }
    });
  };

  const handleActiveButtonClick = () => {
    const selectedValues = selectedOptions.join(",");
    console.log("Selected Values:", selectedValues);
    callbackvalue(selectedValues);
  };

  const handleClearButtonClick = (e) => {
    e.preventDefault()
    setSelectedOptions([]);
  };

  const filteredOptions = options1.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderButtonLabel = () => {
    if (selectedOptions.length > 0) {
      const selectedLabels = options1
        .filter((option) => selectedOptions.includes(option.value.toString()))
        .map((option) => option.label);
      return `${selectedLabels.length} ${placeholder}`;
    }
    return placeholder;
  };

  return (
    <div className="form-group">
      <div className="d-flex">
        <div className="dropdown">
          {/* Dropdown Button */}
          <button
            className="btn btn-secondary btn-drops rounded-0 rounded-start dropdown-toggle"
            type="button"
            id="multiSelectDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {renderButtonLabel()}
          </button>

          {/* Dropdown Menu */}
          <ul
            className="dropdown-menu custom-scrollable-menu"
            aria-labelledby="multiSelectDropdown"
          >
            {/* Search Box */}
            <li className="px-2 py-2 d-flex align-items-center">
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                className="btn btn-link text-decoration-none ms-2"
                onClick={((e) => handleClearButtonClick(e))}
              >
                Clear
              </button>
            </li>
            {/* Options */}
            {filteredOptions.map((option, index) => (
              <li key={option.value} className="dropdown-item">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    value={option.value}
                    checked={selectedOptions.includes(option.value.toString())}
                    onChange={handleChange}
                    className="me-2"
                  />
                  {option.label}
                </label>
              </li>
            ))}
          </ul>

          {/* Apply Filter Button */}
          <button
            title="Apply Filter"
            className="btn btn-secondary rounded-0 rounded-end"
            onClick={handleActiveButtonClick}
          >
            <i className="fas fa-filter"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonMultiSelect;
